var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-speed-dial', {
    attrs: {
      "direction": "left",
      "bottom": "",
      "right": "",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "large": "",
            "color": "accent",
            "dark": "",
            "fab": ""
          },
          model: {
            value: _vm.fab,
            callback: function ($$v) {
              _vm.fab = $$v;
            },
            expression: "fab"
          }
        }, [_vm.fab ? _c('v-icon', [_vm._v("mdi-close")]) : _c('v-icon', [_vm._v("mdi-file-document-edit")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.fab,
      callback: function ($$v) {
        _vm.fab = $$v;
      },
      expression: "fab"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', {
          attrs: {
            "disabled": _vm.isPaylinkDisabled,
            "dark": !_vm.isPaylinkDisabled,
            "fab": "",
            "color": "info"
          },
          on: {
            "click": function ($event) {
              return _vm.openModal('sendOrderPaylink', 'payment', true);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-cash-multiple")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v("(Re)Send Order Payment/Offer")])]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', {
          attrs: {
            "disabled": !_vm.customer || !_vm.orderIsPaid,
            "dark": !(!_vm.customer || !_vm.orderIsPaid),
            "fab": "",
            "color": "pink"
          },
          on: {
            "click": function ($event) {
              return _vm.openModal('sendConfirmationLink', 'order confirmation', true);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-email")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v("(Re)Send Order Confirmation")])]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', {
          attrs: {
            "disabled": !_vm.customer || !_vm.orderIsPaid,
            "dark": !(!_vm.customer || !_vm.orderIsPaid),
            "fab": "",
            "color": "green"
          },
          on: {
            "click": function ($event) {
              return _vm.openModal('sendTicket', 'tickets', false);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-ticket-confirmation")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v("(Re)Send Tickets")])]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', {
          attrs: {
            "disabled": !_vm.customer || !_vm.orderIsPaid,
            "dark": !(!_vm.customer || !_vm.orderIsPaid),
            "fab": "",
            "color": "orange darken-1"
          },
          on: {
            "click": _vm.listReceipts
          }
        }, [_c('v-icon', [_vm._v("mdi-receipt-text-outline")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v("View/Send Receipts")])]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fab": "",
            "dark": "",
            "color": "purple"
          },
          on: {
            "click": function ($event) {
              _vm.inquiryModal = true;
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-cash-plus")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Create Claim Ticket")])]), _vm.orderIsLockRequired ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref6) {
        var on = _ref6.on,
          attrs = _ref6.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fab": "",
            "dark": "",
            "color": "indigo"
          },
          on: {
            "click": function ($event) {
              return _vm.updatelock('unlock');
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-lock-off-outline")])], 1)];
      }
    }], null, false, 1670471749)
  }, [_c('span', [_vm._v("Unlock Order")])]) : _vm._e(), !_vm.isCompany ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref7) {
        var on = _ref7.on,
          attrs = _ref7.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', {
          attrs: {
            "fab": "",
            "color": "teal",
            "disabled": _vm.orderIsFullyPaid || _vm.orderTotalPrice == null || _vm.orderTotalPrice !== 0
          },
          on: {
            "click": function ($event) {
              return _vm.handleDebitDialog('free');
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-cash-remove")])], 1)], 1)];
      }
    }], null, false, 1814616350)
  }, [_c('span', [_vm._v("Debit the Order via Free")])]) : _vm._e(), _vm.isCompany ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref8) {
        var on = _ref8.on,
          attrs = _ref8.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', {
          attrs: {
            "fab": "",
            "color": "danger",
            "disabled": _vm.orderIsFullyPaid || !_vm.userCanInvoice,
            "dark": !(_vm.orderIsPaid || !_vm.userCanInvoice)
          },
          on: {
            "click": function ($event) {
              return _vm.handleDebitDialog('fortnox');
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-cash-check")])], 1)], 1)];
      }
    }], null, false, 3811506803)
  }, [_c('span', [_vm._v("Debit the Order via Invoice ")])]) : _vm._e(), _vm.canAnonymizeOrder ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref9) {
        var on = _ref9.on,
          attrs = _ref9.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fab": "",
            "color": "blue-grey",
            "disabled": _vm.orderIsAnonymized,
            "dark": !_vm.orderIsAnonymized
          },
          on: {
            "click": _vm.anonymizeOrder
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-incognito")])], 1)];
      }
    }], null, false, 2035608128)
  }, [_c('span', [_vm._v("Anonymize Order")])]) : _vm._e(), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref10) {
        var on = _ref10.on,
          attrs = _ref10.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fab": "",
            "disabled": _vm.orderIsPaid,
            "dark": !_vm.orderIsPaid,
            "color": "red"
          },
          on: {
            "click": function ($event) {
              return _vm.archiveOrder();
            }
          }
        }, 'v-btn', attrs, false), on), [_vm.isArchivedOrder ? _c('v-icon', [_vm._v("mdi-archive-off")]) : _c('v-icon', [_vm._v("mdi-archive-arrow-down")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.isArchivedOrder ? "Unarchive order" : "Archive order"))])])], 1), _c('v-dialog', {
    attrs: {
      "max-width": "700px"
    },
    model: {
      value: _vm.sendLinkModal,
      callback: function ($$v) {
        _vm.sendLinkModal = $$v;
      },
      expression: "sendLinkModal"
    }
  }, [_c('v-overlay', {
    attrs: {
      "value": _vm.$store.state.loading,
      "absolute": "",
      "color": "white",
      "opacity": 0.8
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "64",
      "color": "accent"
    }
  })], 1), _c('v-container', [_c('v-card', {
    attrs: {
      "disabled": _vm.$store.state.loading
    }
  }, [_c('v-flex', {
    staticClass: "mb-12"
  }), _c('base-material-card', {
    attrs: {
      "color": "warning",
      "icon": "mdi-alert-circle-outline"
    },
    scopedSlots: _vm._u([{
      key: "after-heading",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-auto body-3"
        }, [_vm._v(" Send " + _vm._s(_vm.dialogTitle) + " "), _c('h3', [_vm._v("Are you sure to send the " + _vm._s(_vm.dialogTitle) + " to the customer?")])])];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "outlined": "",
            "x-large": ""
          },
          on: {
            "click": function ($event) {
              _vm.sendLinkModal = false;
            }
          }
        }, [_vm._v("Not Now ")]), _c('v-spacer'), _vm.sendLinkModal && _vm.dialogMethod !== 'sendOrderPaylink' ? _c('v-btn', {
          attrs: {
            "color": "accent",
            "x-large": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('get-files', _vm.dialogTitle === 'tickets' ? _vm.ticketLanguage.value : _vm.language);
            }
          }
        }, [_vm._v("View Tickets ")]) : _vm._e(), _c('v-btn', {
          attrs: {
            "color": "success",
            "x-large": "",
            "disabled": _vm.isEmailInvalid
          },
          on: {
            "click": _vm.sendAction
          }
        }, [_vm._v("Send ")])];
      },
      proxy: true
    }])
  }, [_c('v-divider', {
    staticClass: "mt-2"
  }), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_vm.dialogTitle === 'order confirmation' && _vm.orderContainsRailPasses ? _c('div', {
    staticClass: "text-h6 mb-2 font-weight-bold"
  }, [_vm._v(" Interrail passes will be attached to the e-mail. ")]) : _vm._e(), _vm.dialogTitle === 'tickets' ? _c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v(" By default, tickets will be sent to each passenger's e-mail address or phone number. ")]), _c('div', {
    staticClass: "d-flex align-start ga-4"
  }, [_c('ValidationObserver', {
    ref: "ticketEmailObserver"
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "email",
      "rules": "email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref11) {
        var errors = _ref11.errors;
        return [_c('v-text-field', {
          staticClass: "mr-4",
          attrs: {
            "label": "Send to a different e-mail address",
            "hint": "Leave empty to send tickets to passengers' e-mail addresses/phone numbers",
            "persistent-hint": "",
            "clearable": "",
            "error-messages": errors
          },
          model: {
            value: _vm.specificEmailAddressToSendTickets,
            callback: function ($$v) {
              _vm.specificEmailAddressToSendTickets = $$v;
            },
            expression: "specificEmailAddressToSendTickets"
          }
        })];
      }
    }], null, false, 777014609)
  })], 1), _c('v-select', {
    attrs: {
      "items": _vm.languages,
      "item-value": "value",
      "persistent-hint": "",
      "label": "Select language",
      "return-object": ""
    },
    model: {
      value: _vm.ticketLanguage,
      callback: function ($$v) {
        _vm.ticketLanguage = $$v;
      },
      expression: "ticketLanguage"
    }
  })], 1)]) : _c('div', [_c('v-row', [_vm.customer ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_vm._v(" Customer's E-mail: "), _c('b', [_vm._v(" " + _vm._s(_vm.customer.email))])]) : _vm._e(), this.isactiveLang ? _c('v-col', {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.languages,
      "item-value": "value",
      "persistent-hint": "",
      "label": "Select language",
      "return-object": ""
    },
    model: {
      value: _vm.language,
      callback: function ($$v) {
        _vm.language = $$v;
      },
      expression: "language"
    }
  })], 1) : _vm._e()], 1)], 1)])], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "1000px",
      "persistent": _vm.$store.state.loading
    },
    on: {
      "input": _vm.clearReceipts
    },
    model: {
      value: _vm.receiptListModal,
      callback: function ($$v) {
        _vm.receiptListModal = $$v;
      },
      expression: "receiptListModal"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "v-sheet theme--dark v-toolbar secondary"
  }, [_c('v-toolbar-title', [_vm._v(" Receipts List ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.clearReceipts();
        _vm.receiptListModal = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.receiptHeaders,
      "items": _vm.receipts,
      "item-key": "receiptData.id",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.receiptData.receiptNumber",
      fn: function (_ref12) {
        var item = _ref12.item;
        return [_c('div', {
          staticClass: "subtitle-2"
        }, [_vm._v(_vm._s(item.receiptData.receiptNumber))])];
      }
    }, {
      key: "item.receiptData.created",
      fn: function (_ref13) {
        var item = _ref13.item;
        return [_vm._v(" " + _vm._s(_vm._f("getFullLocalizedDate")(item.receiptData.created)) + " "), _c('small', [_vm._v("(GMT+" + _vm._s(_vm.getGmtDiff(item.receiptData.created)) + ")")])];
      }
    }, {
      key: "item.receiptData.type",
      fn: function (_ref14) {
        var item = _ref14.item;
        return [_c('v-chip', {
          attrs: {
            "color": item.receiptData.type === 'debit' ? 'primary' : 'third',
            "dark": "",
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.capitalizeFirstLetter(item.receiptData.type)) + " ")])];
      }
    }, {
      key: "item.receiptData.amount",
      fn: function (_ref15) {
        var item = _ref15.item;
        return [_vm._v(" " + _vm._s(item.receiptData.price.plainText) + " ")];
      }
    }, {
      key: "item.receiptData.actions",
      fn: function (_ref16) {
        var item = _ref16.item;
        return [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "loading": item.loading,
            "color": "accent",
            "width": "100%"
          },
          on: {
            "click": function ($event) {
              return _vm.handleViewPdf(item);
            }
          }
        }, [_vm._v(" View PDF "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-file-pdf-box")])], 1)];
      }
    }]),
    model: {
      value: _vm.selectedReceipts,
      callback: function ($$v) {
        _vm.selectedReceipts = $$v;
      },
      expression: "selectedReceipts"
    }
  }), _c('div', {
    staticClass: "d-flex w-100",
    staticStyle: {
      "gap": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('v-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "items": _vm.languages,
      "item-value": "value",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Select language",
      "return-object": ""
    },
    model: {
      value: _vm.receiptLanguage,
      callback: function ($$v) {
        _vm.receiptLanguage = $$v;
      },
      expression: "receiptLanguage"
    }
  })], 1), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "disabled": !!_vm.selectedReceipts.length,
      "color": "black",
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref17) {
        var on = _ref17.on,
          attrs = _ref17.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', {
          attrs: {
            "loading": _vm.sendReceiptEmailLoading,
            "disabled": !_vm.selectedReceipts.length,
            "color": "success",
            "height": "40px",
            "block": ""
          },
          on: {
            "click": _vm.sendReceiptEmail
          }
        }, [_vm._v(" SEND SELECTED RECEIPTS TO THE CUSTOMER E-MAIL ")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Select a receipt in order to send receipt email to the customer")])])], 1)])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "700px"
    },
    model: {
      value: _vm.inquiryModal,
      callback: function ($$v) {
        _vm.inquiryModal = $$v;
      },
      expression: "inquiryModal"
    }
  }, [_c('v-container', [_c('v-card', {
    attrs: {
      "disabled": _vm.$store.state.loading
    }
  }, [_c('v-flex', {
    staticClass: "mb-12"
  }), _c('base-material-card', {
    attrs: {
      "color": "warning",
      "icon": "mdi-alert-circle-outline"
    },
    scopedSlots: _vm._u([{
      key: "after-heading",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-auto"
        }, [_c('div', {
          staticClass: "body-3 grey--text font-weight-light",
          domProps: {
            "textContent": _vm._s('Create a claim')
          }
        }), _c('h3', [_vm._v("Create a claim")])])];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "outlined": "",
            "x-large": ""
          },
          on: {
            "click": function ($event) {
              _vm.inquiryModal = false;
            }
          }
        }, [_vm._v("Not Now ")]), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "loading": _vm.$store.state.loading,
            "color": "success",
            "x-large": ""
          },
          on: {
            "click": _vm.createInquiry
          }
        }, [_vm._v("Create Claim ")])];
      },
      proxy: true
    }])
  }, [_c('v-divider', {
    staticClass: "mt-2"
  }), _c('v-card-text', [_c('ValidationObserver', {
    ref: "inquiryObserver",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref18) {
        var Validate = _ref18.Validate,
          reset = _ref18.reset;
        return [_c('ValidationProvider', {
          attrs: {
            "name": "description",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref19) {
              var errors = _ref19.errors;
              return [_c('v-textarea', {
                attrs: {
                  "filled": "",
                  "label": "Description",
                  "error-messages": errors,
                  "clearable": ""
                },
                model: {
                  value: _vm.inquiryDesc,
                  callback: function ($$v) {
                    _vm.inquiryDesc = $$v;
                  },
                  expression: "inquiryDesc"
                }
              })];
            }
          }], null, true)
        })];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "700px"
    },
    model: {
      value: _vm.debitOrderModal,
      callback: function ($$v) {
        _vm.debitOrderModal = $$v;
      },
      expression: "debitOrderModal"
    }
  }, [_c('div', [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "disabled": _vm.$store.state.loading
    }
  }, [_c('v-flex', {
    staticClass: "pb-12"
  }), _c('base-material-card', {
    attrs: {
      "color": "warning",
      "icon": "mdi-alert-circle-outline"
    },
    scopedSlots: _vm._u([{
      key: "after-heading",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-auto"
        }, [_c('div', {
          staticClass: "body-3 grey--text font-weight-light",
          staticStyle: {
            "margin-top": "-20px"
          },
          domProps: {
            "textContent": _vm._s('Debit the order')
          }
        }), _c('h3')])];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "outlined": "",
            "x-large": ""
          },
          on: {
            "click": _vm.handleCloseDebitDialog
          }
        }, [_vm._v("Not Now ")]), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "loading": _vm.$store.state.loading,
            "color": "success",
            "x-large": ""
          },
          on: {
            "click": _vm.debitTheOrder
          }
        }, [_vm._v("Debit ")])];
      },
      proxy: true
    }])
  }, [_c('v-divider', {
    staticClass: "mt-2"
  }), _c('v-card-text', [_c('h2', {
    staticClass: "mb-2"
  }), _c('h3', [_vm._v("The confirmation mail and tickets WILL be sent automatically.")])])], 1)], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }